<script lang="ts" setup>
const { getHighlights } = useGames()

const { data } = useAsyncData('highlights', () => getHighlights(), {
  getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key] || nuxtApp.static.data[key],
  transform: data => data?.results
})
</script>

<template>
  <div class="col-span-2">
    <div class="flex justify-between items-center my-5 sm:my-0 sm:mb-5">
      <span class="text-2xl font-bold text-slate-100">
        Destaques
      </span>

      <UButton
        variant="link"
        color="primary"
      >
        Ver todos
      </UButton>
    </div>

    <div class="grid grid-cols-2! lg:grid-cols-1! gap-2">
      <UPageCard
        v-for="game in data"
        :key="game.id"
        orientation="horizontal"
        variant="naked"
        reverse
        :title="game.name"
        :ui="{
          body: 'w-full',
          container: 'gap-2! overflow-hidden',
          title: 'text-base font-semibold truncate whitespace-nowrap overflow-ellipsis'
        }"
      >
        <template #description>
          <div class="flex flex-nowrap gap-1">
            <UBadge
              v-for="genre in game.genres.slice(0, 2)"
              :key="genre.id"
              :label="translateCategory(genre.name)"
              color="secondary"
              variant="soft"
            />
          </div>
        </template>

        <template #footer>
          <div class="text-sm text-gray-500 dark:text-gray-400 hidden sm:block">
            {{ game.rating != null ? `⭐ ${Number(game.rating).toFixed(1)}/${game.rating_top ?? 5}` : '' }}
          </div>
        </template>

        <NuxtImg
          :src="game.background_image"
          :alt="game.name"
          placeholder
          format="webp"
          class="w-full aspect-video object-cover rounded-xl"
        />
      </UPageCard>
    </div>
  </div>
</template>
